export enum Language {
    Arabic = 0,
    English = 1
}